import type { ActivityComponentType } from '@stackflow/react';
import { NewConversationPage } from '@/features/messaging';

const NewConversationActivity: ActivityComponentType = () => {
  return <NewConversationPage />;
};

export default NewConversationActivity;
